import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { Expandable } from '../Expandable';
import { Base } from '../Base';
import { disclosureStyles } from './Disclosure.styles';
import { disclosureTheme } from './Disclosure.stylex';
export const Disclosure = createPolymorphicComponent(forwardRef(function Disclosure(props, forwardedRef) {
    const { styles, sx, trigger, children, disabled, expanded, defaultExpanded, initiallyExpanded, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'Disclosure',
        styles: [disclosureStyles, styles],
    });
    return (_jsx(Base, { ...other, sx: [disclosureTheme, globalStyles, combineStyles('host'), sx], ref: forwardedRef, children: _jsx(Expandable, { trigger: trigger, disabled: disabled, expanded: expanded, defaultExpanded: defaultExpanded, initiallyExpanded: initiallyExpanded, children: _jsx("div", { ...getStyles('panel'), children: children }) }) }));
}));
